import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { ActivityTimeline } from "@/components/activity/activity-timeline";

export const Route = createFileRoute("/_authed/_org/cards/$id/activity")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id: cardId } = Route.useParams();
  const { trpc } = Route.useRouteContext();

  const { data: card } = useSuspenseQuery(
    trpc.card.get.queryOptions({
      cardId,
    }),
  );

  return (
    <div className="min-h-0 grow overflow-y-auto px-6 pt-2 pb-4">
      <ActivityTimeline
        events={card.activity.sort(
          (a, b) => b.createdAt.getTime() - a.createdAt.getTime(),
        )}
      />
    </div>
  );
}
